<template>
    <div class="le_content">
        <div v-if="dataArr.length !== 0">
            <ul>
                <li class="le_co_li" v-for="(item,index) in dataArr" :key="index">
                    <div class="le_data">
                        <p><span>{{ item.fupdateTime2 }}</span><br>{{ item.fupdateTime3 }}</p>
                    </div>
                    <p class="le_title" @click="goRoute(item.flawId)">
                        {{ item.flawTitle }}
                    </p>
                    <div class="le_fujian" @click="showFujian(item.flawFileUrl2)">
                        点击查看附件
                    </div>
                    <div class="le_company">
                        皓景环境技术有限公司
                    </div>
                </li>
            </ul>
            <div class="le_div">
                <el-button
                        v-if="moreData"
                        class="le_btn"
                        :loading="false"
                        @click="moreDataFun"
                        type="success"
                        plain>查看更多
                    <i class="el-icon-sort-down el-icon--right"></i>
                </el-button>
                <p v-else class="nomore_data">暂无更多法律规章</p>
            </div>

        </div>
        <div v-else class="no_content">
            暂无法律规则
        </div>
        <el-dialog
                title="附件列表"
                :visible.sync="FJbool"
                @close="FJclose"
                center
                width="534px"
        >
            <ul v-if="FJarr.length !== 0" class="FJWindow">
                <li v-for="(item,index) in FJarr" :key="index">
                    <p>{{ item.name }}</p>
                    <a target="_blank" :href="IMGURL + item.url">点击查看附件</a>
                </li>
            </ul>
            <p class="FJnodata" v-else>暂无附件</p>
        </el-dialog>
    </div>
</template>

<script>
    import axios from '../../assets/js/baseaxios'
    import baseUrl from '../../assets/js/baseUrl'
    export default {
        name: "legisChild",
        props:['typeNum'],
        data(){
            return{
                IMGURL: '',
                current: 5,
                dataArr: [],  //是否有数据
                moreData: false, //更多数据按钮
                FJbool: false, //附件弹窗
                FJarr:[], //附件数据
            }
        },
        mounted(){
            this.IMGURL = baseUrl.IMG_URL
            this.getData()
        },
        methods:{
            getData(){
                axios.get(`/api/law?page=1&limit=${this.current}`,{
                    params:{
                        flawCategory: this.typeNum
                    }
                }).then(res=>{
                    if(res.data.success){
                        let items = res.data.items
                        //是否有数据
                        if(items.length === 0){
                            return
                        }
                        //是否有更多数据
                        if(res.data.total <= this.current){
                            this.moreData = false
                        }else{
                            this.moreData = true
                        }
                        //是否有附件
                        items.forEach(rej=>{
                            if(rej.flawFileUrl.length !==0){
                                let tag = rej.flawFileUrl.split(',')
                                rej.flawFileUrl2 = tag.map(btn=>{
                                    return {
                                        name: btn.slice(btn.replace(/(.*\/)*([^.]+).*/ig,"$1").length),
                                        url: btn
                                    }
                                })
                            }else{
                                rej.flawFileUrl2 = []
                            }
                        })
                        //日期格式处理
                        items.forEach(btn=>{
                            let data = new Date(btn.fupdateTime.replace(/-/g,'/'))
                            let str = this.buwei((data.getMonth() + 1)) + '/' + data.getDate()
                            let str2 = data.getFullYear() + '年'
                            btn.fupdateTime2 = str
                            btn.fupdateTime3 = str2
                        })
                        this.dataArr = items
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            },
            //获取更多数据
            moreDataFun(){
                this.current += 5
                this.getData()
            },
            //附件
            showFujian(arr){
                this.FJbool = true
                if(arr.length === 0)return
                this.FJarr = [...arr]
            },
            //附件窗口关闭
            FJclose(){
                this.FJarr = []
            },
            buwei(val){
                if(val < 10) return '0' + val
                return val
            },
            // 路由跳转
            goRoute(val) {
                this.$router.push({name: 'detail', query: {id: val, name: 'law'}})
            }
        }
    }
</script>

<style scoped>
    .no_content{
        height: 200px;
        line-height: 200px;
        font-size: 14px;
        color: #999;
        text-align: center;
    }
    .le_content ul{
        padding-top: 10px;
        padding-bottom: 40px;
    }
    .le_content .le_co_li{
        display: flex;
        margin-bottom: 30px;
        height: 58px;
        align-items: center;
    }
    .le_content .le_co_li .le_data{
        position: relative;
        width: 58px;
        height: 58px;
        background-color: #00B76B;
        font-size: 12px;
        color: #fff;
        margin-right: 30px;
    }
    .le_data p{
        position: absolute;
        top: 50%;
        width: 100%;
        line-height: 16px;
        transform: translateY(-50%);
        text-align: center;
        font-size: 12px;
        /*letter-spacing: 1px;*/
    }
    .le_data p span{
        font-size: 16px;
    }
    .le_content li .le_title{
        width: 352px;
        line-height: 21px;
        margin-right: 170px;
        color: #333;
        font-size: 16px;
    }
    .le_content li .le_fujian{
        width: 84px;
        color: #00B76B;
        font-size: 14px;
        line-height: 58px;
        cursor: pointer;
        margin-right: 30px;
    }
    .le_content li .le_company{
        width: 370px;
        text-align: right;
        line-height: 58px;
        color: #999;
        font-size: 14px;
    }
    .le_content .le_div{
        text-align: center;
        margin-bottom: 100px;
    }
    .nomore_data{
        color: #999;
        font-size: 14px;
        line-height: 19px;
    }
    .el-button--success.is-plain{
        border-color: #00B76B;
        color: #00B76B;
        background: none;
    }
    .el-button--success.is-plain:focus, .el-button--success.is-plain:hover{
        background: #00B76B;
        border-color: #00B76B;
        color: #fff
    }
    .FJnodata{
        text-align: center;
        color: #999;
        font-size: 14px;
        line-height: 19px;
    }
    .FJWindow li{
        display: flex;
        margin-bottom: 24px;
        justify-content: space-between;
        align-items: center;
    }
    .FJWindow li p{
        width: 266px;
        line-height: 19px;
        font-size: 14px;
        color: #333;
    }
    .FJWindow li a{
        display: block;
        width: 84px;
        font-size: 14px;
        color: #00B76B;
        line-height: 19px;
        text-align: right;
    }
</style>
